import routes from './routes'
import { LobbyEntryProps, LobbyEntryTypes } from './components/LobbyEntry/LobbyEntry'

// audio
import LobbyMusic from './images/audio/lobby.mp3'

// icons & decorations
import { desktopAssets } from './containers/PreCache'
import { GlobalModalTypes } from './components/GlobalModals/modalTypes'

const ENABLE_CHAPORT = true
const dev = {
  apiUrl: 'http://localhost:3000',
}

const prod = {
  apiUrl: 'https://backend.ntc.com.my',
}

const API_KEYS = {
  amplitude: '4abdf449cc1e292c1842fdafeaca658e',
}

const LOBBY_VIDEO = 'https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/e6ce37ae-ee1b-4e04-8a0b-442f752ebb00?autoplay=1&muted=1'
const HALL_VIDEO_URL = 'https://iframe.dacast.com/live/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/6657f084-2e46-458c-ab54-cd665a056823'
const SLIDO_URL = 'https://app.sli.do/event/xkNVuLT3QZmDizJwWqNVZG'
// Served straight out of public/ — kept URL-safe (no spaces) so the link works
// without encoding wherever the build is hosted.
const FAQ_PDF_URL = '/faq-ntc-2026.pdf'
const VOLUME_VALUE = 0.4

// Root page will show either EntrancePage or CountdownPage
// based on the following time setting
const EVENT_START_TIME = {
  year: 2026,
  month: 8,
  day: 4,
  hour: 7,
  minute: 0,
}

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 10%;
    left: 5%;
    right: 32%;
    bottom: 20%;
  `,
}

const lobbyEntries: Array<LobbyEntryProps & { id: string }> = [
  {
    id: 'programme',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.Agenda,
    pinImage: desktopAssets.agendaIcon,
    css: `
      top: 56%;
      left: 79%;
      width: 9% !important;
      height: 18.3% !important;
      animation: float 3s ease-in-out infinite;
      animation-delay: 1000ms;
    `,
    //animation: glowPulse 2s infinite;
  },
  {
    id: 'helpdesk',
    type: LobbyEntryTypes.Helpdesk,
    pinImage: desktopAssets.lobbyHelpDeskIcon,

    css: `
      top: 66%;
      left: 50%;
      animation: float 3s ease-in-out infinite;
      animation-delay: 500ms;
      width: 9% !important;
      display: flex;
      align-items: end;
    `,
    pinImageCss: `
      margin-left: 30% !important
    `,
  },
  {
    id: 'auditorium-entrance',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.auditorium,
    pinImage: desktopAssets.hallIcon,
    css: `
      top: 58%;
      left: 66.6%;
      width: 9% !important;
      animation: float 3s ease-in-out infinite;
      animation-delay: 500ms;
    `,
  },
  {
    id: 'speaker profile',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.Speakers,
    pinImage: desktopAssets.speakerIcon,
    // pinText: "Speaker Profile",
    css: `
      animation: float 3s ease-in-out infinite;
      animation-delay: 100ms;
      top: 64%;
      left: 23.5%;
      width: 120px !important;
      
      @media (min-width: 1440px) {
        width: 150px !important;
      }
    `,
  },
  {
    id: 'gallery-entrance',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.onDemand,
    pinImage: desktopAssets.galleryIcon,
    css: `
      top: 60%;
      left: 10%;
      width: 9% !important;
      animation: float 3s ease-in-out infinite;
      animation-delay: 1500ms;
    `,
  },
  {
    id: 'user-guide',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.Guide,
    pinImage: desktopAssets.userGuideBtn,
    css: `
      top: 90%;
      left: 0;
      width: 30% !important;
    `,
  },
  {
    id: 'faq',
    type: LobbyEntryTypes.ExternalRoute,
    destination: FAQ_PDF_URL,
    pinImage: desktopAssets.faqBtn,
    // Anchored bottom-right, clear of the user guide banner on the left and the
    // fixed nav rail on the right. Clamped so the pill stays close to the
    // artwork's native 227px instead of ballooning on wide monitors.
    css: `
      bottom: 4%;
      right: 6.5%;
      width: clamp(180px, 13vw, 200px) !important;
    `,
  },
  {
    id: 'survey',
    type: LobbyEntryTypes.ExternalRoute,
    destination: routes.survey,
    pinImage: desktopAssets.surveyIcon,
    css: `
      top: 73%;
    left: 34%;   
      width: 8% !important;
      animation: float 3s ease-in-out infinite;
      animation-delay: 1500ms;
    `,
  },
  // {
  //   id: 'exhibition-entrance',
  //   type: LobbyEntryTypes.GlobalModal,
  //   modalId: GlobalModalTypes.EntrySelection,
  //   pinImage: fixedAssets.exhibitionEntrance,
  //   css: `
  //     top: 45%;
  //     left: 63%;
  //     right: 22%;
  //     bottom: 16%;
  //   `,
  //   pinText: "EXHIBITION HALL",
  //   textCss: `
  //     top: 30%;
  //     left: 7%;
  //     right: 22%;
  //     bottom: 42%;
  //     transform: rotateX(0deg) rotateY(-15deg);
  //   `,
  // },
  // {
  //   id: 'welcome video',
  //   type: LobbyEntryTypes.GlobalModal,
  //   modalId: GlobalModalTypes.Welcome,
  //   css: `
  //     top: 30%;
  //     left: 45%;
  //     right: 45%;
  //     bottom: 55%;
  //   `,
  // },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,
  EVENT_START_TIME,
  SLIDO_URL,
  HALL_VIDEO_URL,
  LOBBY_VIDEO,
  FAQ_PDF_URL,
  eventName: 'NTC 2026',
  ENABLE_CHAPORT,

  ...config,
}
